<template>
  <div id="app">
    <header>
      <div class="headers">
        <div class="headers-icon">
          <img src="../assets/img/njklogo.png" alt />
        </div>
      </div>
    </header>
    <div class="login_container">
      <div class="login_content">
        <div class="login_img">
          <img src="../assets/img/login_text.png" alt="" />
        </div>
        <div class="login_box" v-if="type == 0">
          <div class="login_title">
            <div class="login_title_l">登录</div>
            <div class="login_title_r"><a @click="type = 1">免费注册</a></div>
          </div>
          <div>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="phone_error ? '请输入11位手机号码' : ''"
                :show-message="phone_error"
              >
                <el-input
                  placeholder="请输入手机号"
                  prefix-icon="el-icon-mobile-phone"
                  v-model="phone"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="pwd_error ? '密码由8-20位字母，数字和符号组合' : ''"
                :show-message="pwd_error"
              >
                <el-input
                  placeholder="密码由8-20位字母，数字和符号组合"
                  prefix-icon="el-icon-lock"
                  type="password"
                  v-model="pwd"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div class="forget"><a @click="type = 2">忘记密码</a></div>
            <div class="login_btn" @click="loginClick">登录</div>
          </div>
        </div>
        <div class="login_box" v-if="type == 1">
          <div class="login_title">
            <div class="login_title_l">注册</div>
            <div class="login_title_r">
              已注册可<a @click="type = 0">直接登录</a>
            </div>
          </div>
          <div>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="phone_error ? '请输入11位手机号码' : ''"
                :show-message="phone_error"
              >
                <el-input
                  placeholder="请输入手机号"
                  prefix-icon="el-icon-mobile-phone"
                  v-model="phone"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form class="">
              <el-form-item
                class="login_input_line"
                :error="yzm_error ? '验证码错误' : ''"
                :show-message="yzm_error"
              >
                <el-input
                  placeholder="请输入验证码"
                  class="mini"
                  prefix-icon="el-icon-chat-dot-square"
                  v-model="yzm"
                >
                </el-input>
                <div
                  class="yzm_btn"
                  @click="sendyzm(1)"
                  :class="{ sending: sending }"
                >
                  {{ !sending ? "获取验证码" : time + "s" }}
                </div>
              </el-form-item>
            </el-form>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="pwd_error ? '密码由8-20位字母，数字和符号组合' : ''"
                :show-message="pwd_error"
              >
                <el-input
                  placeholder="密码由8-20位字母，数字和符号组合"
                  prefix-icon="el-icon-lock"
                  type="password"
                  v-model="pwd"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="pwd__error ? '两次输入的密码不一致，请重试' : ''"
                :show-message="pwd__error"
              >
                <el-input
                  placeholder="请再次输入上面的密码"
                  prefix-icon="el-icon-lock"
                  type="password"
                  v-model="pwd_"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div class="login_btn" @click="regClick">立即注册</div>
          </div>
        </div>
        <div class="login_box" v-if="type == 2">
          <div class="login_title">
            <div class="login_title_l">找回密码</div>
            <div class="login_title_r">
              已注册可<a @click="type = 0">直接登录</a>
            </div>
          </div>
          <div>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="phone_error ? '请输入11位手机号码' : ''"
                :show-message="phone_error"
              >
                <el-input
                  placeholder="请输入手机号"
                  prefix-icon="el-icon-mobile-phone"
                  v-model="phone"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form class="">
              <el-form-item
                class="login_input_line"
                :error="yzm_error ? '验证码错误' : ''"
                :show-message="yzm_error"
              >
                <el-input
                  placeholder="请输入验证码"
                  class="mini"
                  prefix-icon="el-icon-chat-dot-square"
                  v-model="yzm"
                >
                </el-input>
                <div
                  class="yzm_btn"
                  @click="sendyzm(2)"
                  :class="{ sending: sending }"
                >
                  {{ !sending ? "获取验证码" : time + "s" }}
                </div>
              </el-form-item>
            </el-form>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="pwd_error ? '密码由8-20位字母，数字和符号组合' : ''"
                :show-message="pwd_error"
              >
                <el-input
                  placeholder="密码由8-20位字母，数字和符号组合"
                  prefix-icon="el-icon-lock"
                  type="password"
                  v-model="pwd"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-form>
              <el-form-item
                class="login_input_line"
                :error="pwd__error ? '两次输入的密码不一致，请重试' : ''"
                :show-message="pwd__error"
              >
                <el-input
                  placeholder="请再次输入上面的密码"
                  prefix-icon="el-icon-lock"
                  type="password"
                  v-model="pwd_"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <div class="login_btn" @click="ensureChange">确定</div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <div class="footer-container">
        <div class="links">
          <a href="https://www.nongjike.cn" class="link">首页</a>
          <a href="njzs.html" class="link">农技知识</a>
          <a href="bch.html" class="link">病虫害图谱</a>
          <a href="nzsc.html?type=0" class="link">农资商城</a>
          <a href="zwal.html" class="link">应用案例</a>
          <a href="hdsq.html" class="link">互动社区</a>
          <a href="bl.html" class="link">猫友部落</a>
          <a href="xwzx.html" class="link">新闻中心</a>
          <a href="gywm_u.html" class="link">关于我们</a>
        </div>
        <div class="company">
          <span
            >版权所有：郑州木加林文化传播有限公司
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            网站备案 / 许可证号：
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41010502003873"
              target="_blank"
              >豫公网安备41010502003873号</a
            >
            /
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >豫ICP备14010072号-3</a
            ></span
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data: () => {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);

    gus.id;
    return {
      totalpage: 0,
      currentpage: 1,
      loading: false,
      type: gus.type || 0, // 0登录，1注册，2找回密码
      phone: "",
      pwd: "",
      pwd_: "",
      yzm: "",

      phone_error: false,
      pwd_error: false,
      yzm_error: false,
      pwd__error: false,
      sending: false,
      time: 0,
      timer: "",
      trueYzm: "",
    };
  },
  beforeMount() {
    this.$axios
      .post(
        `https://m.nongjike.cn/app/community/showListResearch?researchId=${this.id}&userId=1234`
      )
      .then((res) => {
        console.log(res);
        this.research = res.data.information[0].researchEntity;
      });
  },
  methods: {
    regClick() {
      var reg = /^1\d{10}$/;
      if (!reg.test(this.phone)) {
        this.phone_error = true;
        return false;
      } else {
        this.phone_error = false;
      }
      if (!this.yzm) {
        this.yzm_error = true;
        return false;
      } else {
        this.yzm_error = false;
      }
      if (!this.pwd) {
        this.pwd_error = true;
        return false;
      } else {
        this.pwd_error = false;
      }
      if (this.pwd != this.pwd_) {
        this.pwd__error = true;
        return false;
      } else {
        this.pwd__error = false;
      }
      if(this.yzm!=this.trueYzm){
        return this.$alert("验证码错误！",'提示');
      }
      this.$axios
        .post(
          `https://m.nongjike.cn/app/njk/register?phone=${this.phone}&nickName=用户${this.phone}&password=${this.pwd}&job=其他&headimgurl=&unionid=&openid=`,
          {
            phone: this.phone,
            nickName : `用户${this.phone}`,
            password: this.pwd,
            job: '其他',
            headimgurl: '',
            unionid: '',
            openid: '',
          }
        )
        .then((res) => {
          let data = res.data;
          if (data.status != 200) {
            this.$alert(data.information || data.message,'提示');
            return false;
          } else {
            this.$alert("注册成功，请前往登录",'提示');
            this.pwd = "";
            this.type = 0;
          }
        });
    },
    loginClick() {
      if (!this.phone) {
        this.phone_error = true;
        return false;
      } else {
        this.phone_error = false;
      }
      if (!this.pwd) {
        this.pwd_error = true;
        return false;
      } else {
        this.pwd_error = false;
      }
      this.$axios
        .post(
          `https://m.nongjike.cn/app/njk/userLogin?phone=${this.phone}&password=${this.pwd}&phoneType=web`,
          {
            phone: this.phone,
            password: this.pwd,
            phoneType: "web",
          }
        )
        .then((res) => {
          let data = res.data;
          if (data.status != 200) {
            this.$alert(data.information || data.message,'提示');
            return false;
          } else {
            this.$alert("登录成功，即将自动跳转自首页...",'提示');
            sessionStorage["USER"] = JSON.stringify(data.information);
            setTimeout(() => {
              location.href = "index.html";
            }, 1500);
          }
        });
    },
    ensureChange() {
      var reg = /^1\d{10}$/;
      if (!reg.test(this.phone)) {
        this.phone_error = true;
        return false;
      } else {
        this.phone_error = false;
      }
      if (!this.yzm) {
        this.yzm_error = true;
        return false;
      } else {
        this.yzm_error = false;
      }
      if (!this.pwd) {
        this.pwd_error = true;
        return false;
      } else {
        this.pwd_error = false;
      }
      if (this.pwd != this.pwd_) {
        this.pwd__error = true;
        return false;
      } else {
        this.pwd__error = false;
      }
      this.$axios
        .post(
          `https://m.nongjike.cn/app/njk/forgetPassword?phone=${this.phone}&password=${this.pwd}&authCode=${this.yzm}`,
          {
            phone: this.phone,
            password: this.pwd,
            authCode: this.yzm,
          }
        )
        .then((res) => {
          let data = res.data;
          if (data.status != 200) {
            this.$alert(data.information || data.message,'提示');
            return false;
          } else {
            this.$alert("密码修改成功，请前往登录",'提示');
            this.pwd = "";
            this.type = 0;
          }
        });
    },
    sendyzm(e) {
      if (this.sending) {
        return false;
      } else {
        var reg = /^1\d{10}$/;
        if (!reg.test(this.phone)) {
          this.phone_error = true;
          return false;
        } else {
          this.phone_error = false;
        }
        this.$axios
          .post(
            `https://m.nongjike.cn/app/njk/createToken?phone=${this.phone}&status=${e}`,
            {
              phone: this.phone,
              status: e,
            }
          )
          .then((res) => {
            console.log(res);
            let data = res.data;
            let token = data.information;
            if (data.status != 200) {
              if (data.information == "该手机号已经注册，请直接登录") {
                this.$alert("该手机号已经注册",'提示');
                return;
              }
              this.$alert(data.information,'提示');
              return false;
            }
            if (!token) {
              return false;
            } else {
              this.$axios
                .post(
                  `https://m.nongjike.cn/app/njk/sendAuthCode?phone=${this.phone}`,
                  { phone: this.phone },
                  {
                    headers: {
                      token: token,
                    },
                  }
                )
                .then((response) => {
                  let data = response.data;
                  if (data.status == 200) {
                    this.$message.success("验证码发送成功！");
                    this.sending = true;
                    this.trueYzm = data.information;
                    this.time = 60;
                    this.timer = setInterval(() => {
                      if (this.time <= 0) {
                        clearInterval(this.timer);
                        this.sending = false;
                      }
                      this.time--;
                    }, 1000);
                  } else {
                    alert(data.information,'提示');
                  }
                });
            }
          });

        // $.ajax({
        //   //创建验证发送短信的token
        //   type: "post",
        //   url: "https://m.nongjike.cn/app/njk/createToken",
        //   async: true,
        //   data: {
        //     phone: this.phone1,
        //   },
        //   success: function (res) {
        //     var data = res;
        //     console.log(data);
        //     var token = data.information;
        //     if (data.status != 200) {
        //       if (data.information == "该手机号已经注册，请直接登录") {
        //         alert("该手机号已经注册");
        //         return;
        //       }
        //       alert(data.information);
        //       return false;
        //     }
        //     if (!!token) {
        //       $.ajax({
        //         type: "post",
        //         url: "https://m.nongjike.cn/app/njk/sendAuthCode",
        //         data: {
        //           phone: _this.phone1,
        //         },
        //         headers: {
        //           token: token,
        //         },
        //         dataType: "json",
        //         success: function (response) {
        //           console.log(response);
        //           if (response.status == 200) {
        //             mui.toast("验证码发送成功！");
        //             _this.sending = true;
        //             _this.trueYzm = response.information;
        //             $("#yzm").focus();
        //             _this.time = 60;
        //             _this.timer = setInterval(function () {
        //               if (_this.time <= 0) {
        //                 clearInterval(_this.timer);
        //                 _this.sending = false;
        //               }
        //               _this.time--;
        //             }, 1000);
        //           } else {
        //             alert(response.information);
        //           }
        //         },
        //       });
        //     }
        //   },
        // });
      }
    },
  },
  filters: {},
  mounted: () => {},
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
header {
  background: #fff;
  height: 100px;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8;
}
.headers {
  margin: 0 auto;
  width: 1200px;
  height: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;

  z-index: 11;
  .headers-icon img {
    width: 202px;
    height: 60px;
    display: block;
    padding: 0;
    margin: 0;
  }
}
.login_container {
  width: 100%;
  height: 650px;
  background: url("../assets/img/login_bg.jpg") no-repeat;
  background-size: cover;
  .login_content {
    width: 1200px;
    height: 650px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .login_img {
      img {
        width: 572px;
        height: 410px;
        display: block;
      }
      width: 572px;
      height: 410px;
    }
  }
}
footer {
  width: 100%;
  .footer-container {
    width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .links {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    a {
      display: block;
      color: #333333;
      padding: 0 10px;
      min-width: 100px;
      border-right: 1px solid #333;
      text-align: center;
      text-decoration: none;
      font-size: 14px;
      &:hover {
        color: #65b825;
      }
      &:last-child {
        border-right: none;
      }
    }
  }
  .company {
    font-size: 14px;
    color: #666;
    a {
      color: #666;
    }
  }
}
.login_box {
  width: 360px;
  min-height: 400px;
  background: #fff;
  padding-bottom: 50px;
  .login_title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    height: 50px;
    border-bottom: 1px solid #e6e6e6;
    .login_title_l {
      font-size: 18px;
      color: #666;
    }
    .login_title_r {
      color: #666;
      font-size: 14px;

      a {
        color: #65b825;
        font-size: 14px;
        text-decoration: none;
      }
    }
  }
  .login_input_line {
    width: 100%;
    padding: 0 30px;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-input {
      height: 46px;
      width: 300px;
      input {
        height: 44px;
      }
    }
    .el-input.mini {
      width: 178px;
    }
  }
  .yzm_btn {
    width: 112px;
    height: 44px;
    text-align: center;
    border: 1px solid #65b825;
    background: #fff;
    color: #65b825;
    font-size: 14px;
    border-radius: 3px;
    line-height: 42px;
    cursor: pointer;
    margin-left: 10px;
  }

  .sendyzm.sending {
    background: #dddddd;
    border-color: #ddd;
    color: #999;
  }
  .forget {
    width: 100%;
    padding: 0 30px;
    display: flex;
    justify-content: flex-end;
    margin: 16px 0 0;
    a {
      font-size: 12px;
      color: #333;
      text-decoration: none;
    }
  }
  .login_btn {
    margin: 30px 30px 0 30px;
    width: 302px;
    height: 46px;
    background: #65b825;
    border-radius: 4px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    line-height: 46px;
  }
}
.el-form-item__content {
  display: flex;
}
a {
  cursor: pointer;
}
</style>
